<template>
  <div>
    <Loading></Loading>
  </div>
</template>

<script>
    import http from "../../services/axios"
    import {
      GET_BACKEND_URL,
      GET_HTTP_CONFIG,
      GET_STUDY,
      LOAD_STUDIES_OF_USER,
      R_NAME_CREATE_A_STUDY, UPDATE_STUDY
    } from "../../services/constants"

    export default {
        name: "CreateStudyLoading",
        created() {
          let studyTemplate = this.$route.query.duplicate ? this.duplicateStudyTemplate : this.bareStudyTemplate

          http.post(this.$store.getters[GET_BACKEND_URL](`v2/studies`), studyTemplate, this.$store.getters[GET_HTTP_CONFIG])
            .then(response => {
            return this.$store.dispatch(GET_STUDY, response.data.id).then(() => {
              this.$router.replace({
                name: R_NAME_CREATE_A_STUDY,
                params:{
                  id: response.data.id,
                }
              })
              return this.$store.dispatch(UPDATE_STUDY)
            })

          })
            .catch(err => {
            console.error(err)
          })
        },

      computed:{
          bareStudyTemplate(){
            return {
              "surveyParamaters": {
                "name": ""
              },
              "userID": this.$store.state.userModule.user.data.id
            }
          },
          duplicateStudyTemplate(){
            let duplicate = Object.assign({}, this.$store.state.dataModule.getStudyState.data)
            duplicate.id = null
            duplicate.published = false
            duplicate.closed = false
            duplicate.dateCreated = null
            duplicate.maxParticipants = -1
            duplicate.maxParticipantsReached = false
            duplicate.sourcingMethod = null
            return duplicate
          }
      }
    }
</script>

<style scoped>

</style>
